import { Flex, Avatar, Text, Button } from "@mantine/core";
import { useContext, useEffect, useCallback } from "react";
import { AppContext } from "src/api/AppContext";
import { ClientCardBg } from "src/utils/constants";
import useAppMain from "src/hooks/useAppMain";
import { useHeaderContext } from "src/api/context/HeaderContext";
import { AiOutlineQrcode } from "react-icons/ai";
import MyAccount from "./MyAccount";
import MySchedule from "./MySchedule";
import { openModal } from "@mantine/modals";
import ViewCode from "./ViewCode";

const ClientHeader = () => {
  const { currentUser } = useContext(AppContext);

  return (
    <Flex
      align={"center"}
      //mx={5}
      bg={ClientCardBg}
      pl={15}
      pr={2}
      py={2}
      style={{
        borderRadius: "35px",
      }}
    >
      <Flex direction={"column"} align={"flex-end"} mx={10}>
        <Text
          size={18}
          fw={500}
        >{`${currentUser?.firstName} ${currentUser?.lastName}`}</Text>
        <Text
          size={14}
          fw={400}
          style={{ overflowX: "hidden", textOverflow: "ellipsis" }}
        >
          {currentUser?.email}
        </Text>
      </Flex>
      <Avatar src={currentUser?.profilePicUrl || ""} size={50} radius={"xl"} />
    </Flex>
  );
};

const ClientDashboard = () => {
  const { currentClient } = useContext(AppContext);
  const { updateHeaderContent } = useHeaderContext();

  useAppMain("", false);
  useEffect(() => {
    updateHeaderContent(<ClientHeader />);
  }, []);

  const handleViewCode = useCallback(() => {
    if (!currentClient?.memberCode) return;
    openModal({
      closeOnClickOutside: false,
      title: "Code",
      children: <ViewCode code={currentClient.memberCode} />,
    });
  }, [currentClient?.memberCode]);

  return (
    <Flex my={10} direction={"column"} justify={"center"} align={"center"}>
      <Button
        fullWidth
        leftIcon={<AiOutlineQrcode />}
        onClick={handleViewCode}
        disabled={!currentClient?.memberCode}
      >
        View Code
      </Button>

      <MySchedule />

      <MyAccount />
    </Flex>
  );
};

export default ClientDashboard;
